import React, { FC, useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl } from 'components/ResolveImage/utils';
import AddNewListingButton from '../../../../../../components/AddNewListingButton';
import DealsLoadingState from 'assets/images/DealsLoadingState.webp';
import LinkDataRoom from 'assets/images/LinkDataRoom.webp';
import EnterpriseReviews from 'assets/images/EnterpriseReviews.webp';

import './EnterpriseSellerEmptyState.styles.scss';
import './EnterpriseSellerEmptyState.styles.responsive.scss';

type EnterpriseSellerEmptyStateProps = {
  className?: string;
};

const EnterpriseSellerEmptyState: FC<EnterpriseSellerEmptyStateProps> = ({
  className,
}) => {
  const { enterprise } = useContext(CurrentUserContext);

  const { isRWC } = enterprise || {};

  const classes = classNames('enterprise-seller-empty-state', className);

  const { t } = useTranslation();

  const Cards = useMemo(
    () => [
      {
        title: isRWC
          ? 'publishUnlimitedDataRoomsForFree'
          : 'publishUnlimitedDealsAndPrivateLinstings',
        image: DealsLoadingState,
      },
      {
        title: 'dealsComeWithBrandedDataRoom',
        image: LinkDataRoom,
      },
      { title: 'closeDealsWithQualifiedBuyers', image: EnterpriseReviews },
    ],
    [isRWC],
  );

  return (
    <div className={classes}>
      <div>
        <h1>
          {t(isRWC ? 'sellFasterRwcEnterprise' : 'sellBusinessesEnterprise', {
            enterprise: enterprise.brandName,
          })}
        </h1>
        <ResolveImage
          src={getImgUrl(enterprise.logo?.url, '320')}
          alt="Enterprise logo."
          asCompanyLogo
        />
      </div>

      <div className="enterprise-seller-empty-state__cards">
        {Cards.map(({ title, image }) => (
          <div key={title}>
            <ResolveImage src={image} asIllustration />
            <p>{t(title)}</p>
          </div>
        ))}
      </div>

      <AddNewListingButton />
    </div>
  );
};

export default EnterpriseSellerEmptyState;
